/*
  Accessibility for product sliders items
*/
(function () {
  if (window.__productSliderA11yLoaded) return;
  window.__productSliderA11yLoaded = true;

  const SLIDER_ROOT = ".bls__product-style-6.slider";

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function getParts(root) {
    if (!root) return null;
    const slidesWrapper = root.querySelector(".slides-wrapper");
    const slides = slidesWrapper
      ? Array.from(slidesWrapper.querySelectorAll(".slides > .slide"))
      : [];
    const dots = Array.from(root.querySelectorAll(".dots .dot"));
    return { root, slidesWrapper, slides, dots };
  }

  function ensureIdsAndBindings(parts) {
    const { root, slides, dots } = parts;
    const sliderId =
      root.getAttribute("data-slider-id") ||
      Math.random().toString(36).slice(2);

    slides.forEach((slide, idx) => {
      const desiredId = `slide-${sliderId}-${idx + 1}`;
      if (!slide.id) slide.id = desiredId;
    });

    dots.forEach((dot, idx) => {
      const targetId = slides[idx] ? slides[idx].id : undefined;
      if (targetId) dot.setAttribute("aria-controls", targetId);
      // Inicia aria-current en el activo, o falso
      if (!dot.hasAttribute("aria-current")) {
        dot.setAttribute(
          "aria-current",
          dot.classList.contains("active") ? "true" : "false"
        );
      }
    });
  }

  function updateActive(parts, index) {
    const { dots, slides } = parts;
    dots.forEach((d, i) => {
      if (i === index) {
        d.classList.add("active");
        d.setAttribute("aria-current", "true");
      } else {
        d.classList.remove("active");
        d.setAttribute("aria-current", "false");
      }
    });

    if (slides && slides.length) {
      slides.forEach((slide, slideIdx) => {
        const link = slide.querySelector("a");
        if (!link) return;
        if (slideIdx === index) {
          slide.setAttribute("aria-hidden", "false");
          link.removeAttribute("tabindex");
        } else {
          slide.setAttribute("aria-hidden", "true");
          link.setAttribute("tabindex", "-1");
        }
      });
    }

    try {
      const live = parts.root.querySelector(".sr-live");

      if (live) {
        const { slides } = parts;
        const slideEl = slides[index];
        let altText = "";

        if (slideEl) {
          const img = slideEl.querySelector("img");
          altText = (img && (img.getAttribute("alt") || img.alt)) || "";
        }

        // if (!altText) {
        //   const titleSpan =
        //     parts.root.querySelector(
        //       '.bls__product-img [aria-hidden="false"]'
        //     ) || document.createElement("span");
        //   altText =
        //     titleSpan.textContent ||
        //     parts.root.getAttribute("data-product-handle") ||
        //     "Product image";
        // }

        live.textContent = altText;
      }
    } catch (_) {}
  }

  function goTo(parts, index, smooth = true) {
    const { slidesWrapper, slides } = parts;
    if (!slidesWrapper || !slides || !slides.length) return;
    const maxIdx = slides.length - 1;
    const idx = clamp(index, 0, maxIdx);
    const target = slides[idx];
    if (!target) return;

    const left = target.offsetLeft;
    try {
      slidesWrapper.scrollTo({ left, behavior: smooth ? "smooth" : "auto" });
    } catch (_) {
      slidesWrapper.scrollLeft = left;
    }

    updateActive(parts, idx);
  }

  function getIndexFromDot(parts, dotEl) {
    return parts.dots.indexOf(dotEl);
  }

  function initSlider(root) {
    const parts = getParts(root);
    if (
      !parts ||
      !parts.slidesWrapper ||
      parts.slides.length === 0 ||
      parts.dots.length === 0
    )
      return;

    ensureIdsAndBindings(parts);

    let initialIndex = parts.dots.findIndex((dot) =>
      dot.classList.contains("active")
    );

    if (initialIndex < 0) {
      initialIndex = parts.dots.findIndex(
        (dot) => dot.getAttribute("aria-current") === "true"
      );
    }

    if (initialIndex < 0) initialIndex = 0;

    updateActive(parts, initialIndex);

    // Sync state when the user scrolls manually (inertia)
    let scrollRAF = null;
    parts.slidesWrapper.addEventListener(
      "scroll",
      () => {
        if (scrollRAF) return;
        scrollRAF = requestAnimationFrame(() => {
          scrollRAF = null;
          const { slidesWrapper, slides } = parts;
          const scrollLeft = slidesWrapper.scrollLeft;
          let nearestIdx = 0;
          let minDelta = Infinity;
          for (let i = 0; i < slides.length; i++) {
            const delta = Math.abs(slides[i].offsetLeft - scrollLeft);
            if (delta < minDelta) {
              minDelta = delta;
              nearestIdx = i;
            }
          }
          updateActive(parts, nearestIdx);
        });
      },
      { passive: true }
    );

    // Store reference for event delegation reuse
    root.__a11yParts = parts;
  }

  function findSliderFromDot(target) {
    const root = target.closest(SLIDER_ROOT);
    if (!root) return null;
    if (!root.__a11yParts) initSlider(root);
    return root.__a11yParts || getParts(root);
  }

  document.addEventListener("focusin", (ev) => {
    const dot = ev.target.closest && ev.target.closest(`${SLIDER_ROOT} .dot`);
    if (!dot) return;
    const parts = findSliderFromDot(dot);
    if (!parts) return;
    const idx = getIndexFromDot(parts, dot);
    if (idx < 0) return;
    goTo(parts, idx, true);
  });

  // Initialize existing sliders in the current DOM
  function initAll() {
    document.querySelectorAll(SLIDER_ROOT).forEach(initSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
